<template>
  <div class="card is-min-width-700" v-if="regroupementProduit">
    <header class="bandeau-modal card-header"></header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t(
              'addEditMarche.produits.regroupementProduit',
              { name: regroupementProduit.code })
            }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <produits
        :regroupementProduit="regroupementProduit"
        detail
      />
    </div>
  </div>
</template>

<script>
import { get } from '@/api/produit/regroupementProduit';
import messageErreur from '@/services/general/messageErreur';
import Produits from '@/components/presse/regroupementProduit/produits';

export default {
  name: 'PopupRegroupementProduit',
  components: {
    Produits,
  },
  props: {
    regroupementId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      regroupementProduit: null,
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.regroupementProduit = (await get(this.regroupementId)).data.result;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>
</style>
